/**
 * @returns true se a data data1 for maior ou igual a data2
 */
export function comparaDatasDia(data1: Date, data2: Date) {
    const dataClone1 = new Date(data1);
    const dataClone2 = new Date(data2);
    dataClone1.setHours(23, 59, 59, 99);
    dataClone2.setHours(0, 0, 0, 0);
    return data1 >= dataClone2;
}

// Validates that the input string is a valid date formatted as "yyyy-mm-dd"
export function dateIsValid(dateString: string) {
    // First check for the pattern
    if (!/^\d{4}-\d{1,2}-\d{1,2}$/.test(dateString)) return false;

    // Parse the date parts to integers
    var parts = dateString.split("-");

    var day = parseInt(parts[2], 10);
    var month = parseInt(parts[1], 10);
    var year = parseInt(parts[0], 10);

    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month === 0 || month > 12) return false;
    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
        monthLength[1] = 29;

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
}

export function getDateNow(): string {
    const dataAtual: Date = new Date();
    const ano: number = dataAtual.getFullYear();
    const mes: string = ("0" + (dataAtual.getMonth() + 1)).slice(-2);
    const dia: string = ("0" + dataAtual.getDate()).slice(-2);
    const dataFormatada: string = `${ano}-${mes}-${dia}`;
    return dataFormatada;
}
